import { ConditionalOfferNotice } from 'components/ApplicationOverview/ConditionalOfferNotice/ConditionalOfferNotice';
import { DisabledEarlyRepaymentCalculator } from 'components/EarlyRepaymentCalculator/DisabledEarlyRepaymentCalculator';
import { EarlyRepaymentCalculator } from 'components/EarlyRepaymentCalculator/EarlyRepaymentCalculator';
import { Offer } from 'components/SummaryCard/SummaryCard.helpers';
import { useLocale } from 'hooks/useLocale';
import { ConfirmOffer } from './ConfirmOffer/ConfirmOffer';
import { RejectOffer } from './RejectOffer/RejectOffer';
import { useReviewOffer } from './ReviewOffer.context';

export const ReviewOffer = () => {
  const { isUK } = useLocale();

  const {
    hasMultipleOffers,
    selectedOfferId,
    selectedApplication,
    offerDecision,
    selectedOfferMonthlyRepayment,
  } = useReviewOffer();

  const selectedOffer =
    selectedApplication?.formal_offer_sets?.[0]?.formal_offers?.find(
      (offer) => offer.offer_id === selectedOfferId,
    );

  const { available_funds, max_amount } =
    selectedApplication?.formal_offer_sets[0]?.formal_offers[0] || {};
  const availableFundsEqualOfferedAmount = available_funds === max_amount;
  const isTopUpOffer =
    available_funds && max_amount && !availableFundsEqualOfferedAmount;

  const showCalculator =
    (selectedOffer || !hasMultipleOffers) &&
    selectedApplication &&
    !isTopUpOffer &&
    offerDecision === Offer.UNDECIDED;

  const showDisabledCalculator =
    hasMultipleOffers &&
    !isTopUpOffer &&
    !selectedOffer &&
    offerDecision === Offer.UNDECIDED;

  const showConditionalOfferNotice =
    selectedApplication?.status === 'conditional_offer' &&
    isUK &&
    offerDecision !== Offer.REJECT;

  return (
    <div data-testid="review-offer">
      {showConditionalOfferNotice && (
        <ConditionalOfferNotice
          vatMonthsRequired={selectedApplication?.vat_months_required}
          hasMultipleOffers={hasMultipleOffers}
        />
      )}
      {showCalculator && (
        <EarlyRepaymentCalculator
          formalOffer={
            selectedOffer ||
            selectedApplication?.formal_offer_sets?.[0]?.formal_offers[0]
          }
          selectedOfferMonthlyPayments={selectedOfferMonthlyRepayment}
        />
      )}
      {showDisabledCalculator && <DisabledEarlyRepaymentCalculator />}
      {offerDecision === Offer.AGREE && selectedOffer && (
        <ConfirmOffer
          selectedOffer={selectedOffer}
          isRepeat={selectedApplication?.customer?.is_repeat && isUK}
        />
      )}
      {offerDecision === Offer.REJECT && <RejectOffer />}
    </div>
  );
};
